import type { IconType } from 'react-icons';
import {
    TbAutomation,
    TbBolt,
    TbBulb,
    TbChartLine,
    TbCode,
    TbPalette,
    TbPhotoVideo,
    TbSeo,
    TbSocial,
    TbSpeakerphone,
    TbTargetArrow,
    TbWorldCode,
} from 'react-icons/tb';

const iconBySlug: Record<string, IconType> = {
    'marketing-strategy': TbTargetArrow,
    'social-media-content': TbSocial,
    'photography-videography-cgi': TbPhotoVideo,
    'branding-visual-identity': TbPalette,
    'web-development-solutions': TbWorldCode,
    'seo-geo-visibility': TbSeo,
    'paid-advertising-campaigns': TbSpeakerphone,
    'marketing-technology-automation': TbAutomation,
};

const iconByName: Record<string, IconType> = {
    target: TbTargetArrow,
    share: TbSocial,
    camera: TbPhotoVideo,
    film: TbPhotoVideo,
    palette: TbPalette,
    globe: TbWorldCode,
    code: TbCode,
    search: TbSeo,
    megaphone: TbSpeakerphone,
    barchart: TbChartLine,
    zap: TbAutomation,
    rocket: TbBolt,
    brain: TbBulb,
    star: TbBulb,
};

interface ServiceIconProps {
    slug?: string | null;
    iconName?: string | null;
    className?: string;
}

export function getServiceIconComponent(slug?: string | null, iconName?: string | null) {
    const normalizedSlug = slug?.toLowerCase();
    const normalizedIconName = iconName?.toLowerCase();

    if (normalizedSlug && iconBySlug[normalizedSlug]) {
        return iconBySlug[normalizedSlug];
    }

    if (normalizedIconName && iconByName[normalizedIconName]) {
        return iconByName[normalizedIconName];
    }

    return TbTargetArrow;
}

export function ServiceIcon({ slug, iconName, className = 'h-6 w-6' }: ServiceIconProps) {
    const Icon = getServiceIconComponent(slug, iconName);

    return <Icon aria-hidden="true" className={className} focusable="false" />;
}
